import { useEffect, useState, useRef, useCallback, useContext, useMemo, Ref } from "react";
import * as React from 'react';
import {
  Map, MapboxStyle, useMap, MapRef, MapLayerMouseEvent, Popup,
  FullscreenControl,
  NavigationControl,
  GeolocateControl,
  useControl,
  Layer,
  Source,
  FillLayer,
} from "react-map-gl";
import settings from "../../../settings.json";
import { Form, Button, Row, Col, Table, Container } from "react-bootstrap";
import MapboxDraw from "@mapbox/mapbox-gl-draw";
import agent from "../../../api/agent";
import { formatRowValue } from "../../utils";

import LoadingDataAnimation from "../../../components/LoadingDataAnimation";
import { Feature, GeoJsonProperties, Point, Polygon, GeometryCollection, FeatureCollection, Geometry } from 'geojson';
import type { LayerProps } from 'react-map-gl';
import { FullScreen, useFullScreenHandle } from "react-full-screen";

import moment from 'moment';
import * as d3Array from 'd3-array';
import * as d3Format from 'd3-format';
import * as d3Scale from 'd3-scale';
import * as d3ScaleChromatic from 'd3-scale-chromatic';
import bbox from '@turf/bbox';
import booleanPointInPolygon from '@turf/boolean-point-in-polygon';
import { DateTime } from 'luxon';
import { parse } from 'papaparse';
import { ToastContainer, toast } from 'react-toastify';
import { message_hucrestriction, message_nodatalocation, message_noresult } from '../../../Constants';
import { AppContext } from '../../../AppContext';
import { CatalogsContext } from '../../../CatalogsProvider';
import { Location, useLocation } from 'react-router-dom';
import MapLegend from '../shared/MapLegend';
import FilterState from '../shared/FilterState';
import MapAddition from  '../shared/MapAddition';
import ReportHeader from '../shared/ReportHeader';
import ReportFooter from '../shared/ReportFooter';
import ReportMap from '../shared/ReportMap';
import ReportTableExpanded from '../shared/ReportTableExpanded';
import MapSlider from "../shared/MapSlider";
import {
  useTable, useExpanded, HeaderGroup,
  HeaderProps
} from 'react-table'

import { flyToHUC12sLocation, flyToInitialLocationHandler, getCurrentHuc12LongLat, getHuc12MembersOfHUC8, getCurrentHuc8LongLat } from '../../utils';
import Render from "../../../components/render";
import { RefContext } from '../../../RefContext';
import { createFeatureCollection, processStatusMessage, uniqueValues, updateChartData, groupByKey, fitBoundsMapData, findFittingDateRange } from '../shared/report-data';

import './styles.scss'
//--IMAGES
import companyIcon from "../../../assets/company-icon.svg";
import arrowDownIcon from "../../../assets/arrow-down-icon.svg";
import arrowUpIcon from "../../../assets/arrow-up-icon.svg";
import arrowDownDoubleIcon from "../../../assets/arrow-down-double-icon.svg";
import arrowDownDoubleTreeIcon from "../../../assets/arrow-down-double-tree-icon.svg";
import fullscreenIcon from "../../../assets/fullscreen-icon.svg";
import ellipsisIcon from "../../../assets/ellipsis-icon.svg";

import '@mapbox/mapbox-gl-draw/dist/mapbox-gl-draw.css'
import { features } from "process";
import { Line, Bar, getElementAtEvent, getElementsAtEvent } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  TimeScale,
  RadialLinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler,
  ChartDataset, ChartType, TooltipItem, registerables
} from "chart.js";
import zoomPlugin from 'chartjs-plugin-zoom';

import { Radar } from 'react-chartjs-2';
import { result } from "lodash";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  TimeScale,
  RadialLinearScale,
  Title,
  Tooltip,
  Legend,
  Filler,
  zoomPlugin
);

export default function PfasProduction(props: any) {
  const { global } = props;
  const appContext = useContext(AppContext);
  const catalogsContext = useContext(CatalogsContext);
  let selectedHUC8Value = appContext.selectedHUC8;

  const selectedCategory = (global.filter1Selected || '');
  let selectedDateRange = global.dateRangeSelected;

  const selectedFilterLocations = global.filterLocationsSelected;
  const selectedContaminants = global.chemicalsSelected;
  const selectedYear = global.selectedYearFilter;

  const location: Location = useLocation();
  //@ts-ignore
  const routeData = location.state?.data;

  const { current: map } = useMap();
  const [popupInfo, setPopupInfo] = useState<any>(null);
  const [cursor, setCursor] = useState<string>('');
  const mapRef = useRef<MapRef>();
  const [mapLoaded, setMapLoaded] = useState(false);
  const locationField = 'Facility Name';
  const yearField = 'Reporting Year';
  const chemicalField = 'Chemical Name';
  const [mapHoverFilter, setMapHoverFilter] = useState<any>(['in', ['get', locationField], '']);
  const [mapLegendData, setMapLegendData] = useState<any[]>([]);
  const [circleColorStyle, setCircleColorStyle] = useState<any>([]);
  const [mapStyleData, setMapStyleData] = useState<any>([]);
  const [huc8LonLatCatalogArray, setHuc8LonLatCatalogDataArray] = useState<any[]>([]);
  const [huc12InfoCatalogArray, setHuc12InfoCatalogDataArray] = useState<any[]>([]);
  const [userSelectedLocation, setUserSelectedLocation] = useState<any>(null);
  const [userSelectedLocations, setUserSelectedLocations] = useState<any[]>([]);
  const [usLocations, setUsLocations] = useState<any>([]);
  const [hoverLocation, setHoverLocation] = useState<any>([]);
  const [clickLocation, setClickLocation] = useState<any>([]);

  const [nationalArray, setNationalArray] = useState<any[]>([]);

  const [dataLoaded, setDataLoaded] = useState(false);
  const [features, setFeatures] = useState({});
  const [featureData, setFeatureData] = useState<FeatureCollection>();
  const [reportData, setReportData] = useState<any[]>([]);
  const [filteredData, setFilteredData] = useState<any[]>([]);

  const [statusMessage, setStatusMessage] = useState<any>(null);
  const [layerStyle, setLayerStyle] = useState<any>([]);
  const [hoverLayerStyle, setHoverLayerStyle] = useState<any>([]);
  const [currentDate, setCurrentDate] = useState<any>(null);
  const chartRef = useRef<any>();
  const [filterLabelDays, setFilterLabelDays] = useState<any>([]);

  const divergingColors = ['#d73027', '#74add1', '#f46d43', '#fdae61', '#fee090', '#ffffbf', '#e0f3f8', '#abd9e9', '#74add1', '#4575b4'];
  const reportTypes = ['UCMR-4', 'UCMR-3', 'UCMR-2', 'UCMR-1 Chemical', 'UCMR-4 Microbial'];
  const chartFields = ["Maximum Analytical Value", "Minimum Analytical Value", "Minimum Reporting Level"];
  const chartFieldsInternal = ["Maxanalyticalvalue", "Minanalyticalvalue", "Meanmrl"];
  const colorsWaterType = {'PFAS Detected': '#d73027', 'Present Below Quantification Limit': '#6a3d9a','Below Reporting Limit': '#74add1', 'Not Detected': '#e0f3f8',  'GU': '#b15928', 'Other': '#abd9e9'} 

 
  const [data, setData] = useState({
    labels: [] as any,
    datasets: [] as any,
  } as const);

  const [config, setConfig] = useState({} as const);
  const [isDataReportLoaded, setIsDataReportLoaded] = useState(false);
  const [isTableSort, setTableSort] = useState(true);
  const FullScreenComp = FullScreen as any;
  const fullscreenhandle = useFullScreenHandle() as any;
  const [isFullScreenActive, setFullScreenActive] = useState(false);
  const [isFullScreenChartActive, setFullScreenChartActive] = useState(false);
  const fullscreenContainerHandler = () => { setFullScreenActive(!isFullScreenActive); };
  const fullscreenChartContainerHandler = () => { setFullScreenChartActive(!isFullScreenChartActive); };


  useEffect(() => {
    global.setUserLogged(true);
    if(global.trackerOn) global.setTrackerOn(false)
  }, []);

  const { setCurrentRef } = useContext(RefContext);
  useEffect(() => { setCurrentRef?.(mapRef) }, [mapRef])
  const reportBounds = mapRef.current ? mapRef.current.getMap().getBounds().toArray().flat() : null;

  useEffect(() => {
    let isCanceled = false;
    const pfas_production_dataURL = '/csv/pfas_production_data_202211011349.csv';
    fetch(pfas_production_dataURL)
      .then(response => response.text())
      .then(responseText => {
        if(!isCanceled){
            const data: any[] = parse(responseText, {
                header: true,
            }).data;
            const cleanDataArray = [];
            for (let dataItem of data) {
                if(dataItem.latitude !== '-'){
                    dataItem.Latitude = dataItem.latitude;
                    dataItem.Longitude = dataItem.longitude;
                    dataItem.centroid_latitude = dataItem.Latitude; 
                    dataItem.centroid_longitude = dataItem.Longitude; 
                    dataItem.latlng = '' + dataItem.Latitude + dataItem.Longitude; 
                    cleanDataArray.push(dataItem );
                }
            }

            setNationalArray(cleanDataArray);
        }
      })
      .catch(err => {
        console.log(err)
      });
      return () => {
        isCanceled = true
      }
  }, []);

  useEffect(() => {
    if(nationalArray && nationalArray.length>0){
        const featureCollectionFromReportData = createFeatureCollection([...nationalArray], catalogsContext.huc12Catalog, huc12InfoCatalogArray, selectedHUC8Value);
        setFeatureData(featureCollectionFromReportData);
        if (featureCollectionFromReportData.features.length > 0) {
          if (mapRef && mapRef.current) {
            const mapRef_ = mapRef;
            setTimeout(() => {
              fitBoundsMapData(featureCollectionFromReportData, mapRef_)
            }
              , 400);
          }
        }
    }
  }, [nationalArray]);

  useEffect(() => {
    global.setfilterLocationsSelected([]);
    global.setChemicalsSelected([]);
    //global.setSelectedYearFilter([]);
  }, []);

  useEffect(() => {
    setFilteredData([]);
    setReportData([]);
    setUserSelectedLocations([]);
    global.setfilterLocationsSelected([]);
    global.setChemicalsSelected([]);
    //global.setSelectedYearFilter([]);
  }, [selectedHUC8Value]);

  useEffect(() => {
    let filterData = [...filteredData];
    if ((userSelectedLocations) && (userSelectedLocations.length > 0) && (userSelectedLocations.indexOf('All') < 0)) {
      filterData = filterData.filter((o: any) => userSelectedLocations.indexOf(o[locationField]) > -1);
      sortFilterReportData([...filterData], isTableSort)
    } else {
      filterReportData();
    } 
  }, [userSelectedLocations]);


  useEffect(() => {
    if(statusMessage){
        //global.notify(statusMessage)
    }
  }, [statusMessage]);

  useEffect(() => {
    setIsDataReportLoaded(false);
    queryData(0, [], true, selectedHUC8Value);

  }, [selectedHUC8Value]);

  const checkData = (page: any, data:any, updatedata:boolean, huc:any) => {
    if(page===4){
        updateData(data);
        return;
    } else {
        queryData(page+1, data, updatedata, huc)
    }
  }


  const queryData = (page: any, data:any, updatedata:boolean, huc:any) => {
/*    if(selectedHUC8Value && global.hucRestrict.length>0 && (global.hucRestrict.indexOf(selectedHUC8Value) < 0)){
        setIsDataReportLoaded(true);
        return global.notify(message_hucrestriction);
    }*/

    agent.Reports.PFASPr(selectedHUC8Value, page, 100).then((res: any) => {
        if(page === 0){
            //flyToInitialLocationHandler(selectedHUC8Value, mapRef, catalogsContext.huc8Catalog);
        }

        const returnStatus = processStatusMessage(res);
        //setStatusMessage(returnStatus.statusMessage)
        if (returnStatus.Abort) {
          setIsDataReportLoaded(true);
          return;
        }

        if (!res.body || res.body.length < 1 || !res.body[0].data || res.body[0].data.length < 1) {
            setIsDataReportLoaded(true);
            //setStatusMessage("No result.")
            return;
        }

        const resDataArray = [];
        for (var i = 0; i < res.body.length; i++) {
            for (var j = 0; j < res.body[i].data.length; j++) {
                resDataArray.push(res.body[i].data[j])
            }
        } 
  
        let returnedData = [...resDataArray];
        if (!returnedData || !returnedData.length || returnedData.length < 1) {
          setIsDataReportLoaded(true);
          setStatusMessage("No result.")
          return;
        } 
     
        returnedData = [...resDataArray].concat(data);     
        if(res.body.length > 99){
            checkData(page, returnedData, updatedata, huc);
        } else {
            updateData(returnedData);
        }
    });
  }


  const updateData = (returnedData: any) => {
    const chemLabels = uniqueValues(returnedData, 'Chemical Name');
    global.setChemicalsFilerOptions(['All', ...chemLabels]);
    const siteTypeLabels = uniqueValues(returnedData, locationField );
    const siteLabels = uniqueValues(returnedData, locationField) ;
    const siteFilter = siteLabels.map((x: any, index: number) => ({ huc12: x, hucname: x }));
    global.setfilterLocationsPopulated([{ 'hucname': 'All', 'huc12': 'All' }, ...siteFilter]);
    const yearLabels = uniqueValues(returnedData, yearField );
    global.setSelectedYearFilterOptions(['All', ...yearLabels]);

    for (let dataItem of returnedData) {
        dataItem.centroid_latitude = dataItem.Latitude; //+++
        dataItem.centroid_longitude = dataItem.Longitude; //+++ 
        dataItem.latlng = '' + dataItem.Latitude + dataItem.Longitude; 
        dataItem.radius = 14;
        dataItem.name = dataItem[locationField];
    };

    setReportData(returnedData);
    const fData = returnedData;
    //updateFilters(fData);
    setFilteredData(fData);

/* 
    const _legendData = resultLabels.map((x: any, index: number) => ({ sortindex: colorTypeSort(x), typecode: x, color: colorType(x) }));
    const legendData = _legendData.sort((x: any, y: any) => x['sortindex'] - y['sortindex']);
    setMapLegendData(legendData);

    const _mapStyleData = resultLabels.map((x: any, index: number) => ([x, colorType(x)])).flat();
    _mapStyleData.push("#fee090")
    setMapStyleData(_mapStyleData);

    const circleColorStyle: Array<any> = ['match', ['get', 'Result Detection']];
    circleColorStyle.push(_mapStyleData)
    setCircleColorStyle(circleColorStyle);   */  
    setIsDataReportLoaded(true); 
  }

  useEffect(() => {
    updateLayerStyle();
    updateHoverLayerStyle();
  }, [isDataReportLoaded]);

  const colorType = (selectedtype: string) => {
    if(colorsWaterType[selectedtype as keyof typeof colorsWaterType]){
      return colorsWaterType[selectedtype as keyof typeof colorsWaterType];
    } else {
      return "#fee090";
    }
  }

  const colorTypeSort = (selectedtype: string) => {
    if(selectedtype ==='PFAS Detected'){return 0;}
    else if(selectedtype ==='Present Below Quantification Limit'){return 1;}
    else if(selectedtype ==='Below Reporting Limit'){return 2;}
    else if(selectedtype ==='Not Detected'){return 3;}
    else {return 4;}
  }

  const updateLineChartData = (filterData: any, groupKey: string, selectedCategory: string) => {
    if(!filterData || filterData.length < 1){
        return;
    }

    let fDataset = [...filterData].filter((o: any) => filterData[0][locationField].indexOf(o[locationField]) > -1).sort((x: any, y: any) => x[groupKey].toLowerCase().localeCompare(y[groupKey].toLowerCase()));

    const yearLabels = uniqueValues(fDataset, 'Year');
    if(yearLabels.length > 1 && selectedContaminants.length !==1 && selectedContaminants.indexOf('All')<0){
        fDataset = [...fDataset].filter((o: any) => yearLabels[yearLabels.length-1] === o['Year'])
    }
 
    const mappedValuesResult = fDataset.map((x: any) => (x["Result Measure Value"]===null) ? 0 : x["Result Measure Value"]);
    const mappedValuesMeasure = fDataset.map((x: any) => x["Detection Quantitation  Measure Value"]);
    const groupedresults = groupByKey<any, any>(fDataset, i => i[groupKey]);
    const chartLabels = uniqueValues(fDataset, groupKey).sort((x: any, y: any) => x.localeCompare(y))
    const chartdata_data: any[] = [];
    let chartdata_labels: any[] = [];

    const chartGroup = [];
    chartGroup.push({name: "Detection Quantitation  Measure Value", data: mappedValuesMeasure, radius: 3, radiushover: 5, color: '#6a3d9a', fill: false, colorfill: '#6a3d9a'});
    chartGroup.push({name: "Result Measure Value", data: mappedValuesResult, radius: 8, radiushover: 12, color:d3ScaleChromatic.schemePaired[0], fill: true, colorfill: 'rgba(201,225,238,.7)'});
    for (let dataItem of chartGroup) {
            let dataObject = {
            fill: dataItem.fill,
            label: dataItem.name,
            data: dataItem.data,
            borderColor: dataItem.color,
            backgroundColor: dataItem.colorfill,
            pointRadius: dataItem.radius,
            pointHoverRadius: dataItem.radiushover
        }
        chartdata_data.push(dataObject);
    }

    chartdata_labels = chartLabels.map((x: any) => x.substr(0, 25));
    const chartdata = {
      labels: chartdata_labels,
      datasets: chartdata_data,
      borderColor: '#ff6384',
    }

    return chartdata; 
  }

  const filterReportData = () => {
    let filterData = [...reportData];
    if (reportData.length > 0) {
      if (selectedYear && selectedYear !== 'All') {
        const filterYearData = filterData.filter((o: any) => (+o[yearField] === +selectedYear));
          filterData = filterYearData;
      }

      if ((selectedFilterLocations) && (selectedFilterLocations.length > 0) && (selectedFilterLocations.indexOf('All') < 0)) {
          filterData = filterData.filter((o: any) => selectedFilterLocations.indexOf(o[locationField]) > -1);
      }
      
      if ((selectedContaminants) && (selectedContaminants.length > 0) && (selectedContaminants.indexOf('All') < 0)) {
         filterData = filterData.filter((o: any) => selectedContaminants.indexOf(o[chemicalField]) > -1);
      } 

      sortFilterReportData([...filterData], isTableSort)
     }
  }

  const sortFilterReportData = (unsortedData: any, ascending: boolean) => {
    let filterData = unsortedData;
    setFilteredData(filterData);
  }

  useEffect(() => {
    filterReportData();
  }, [selectedYear, selectedFilterLocations, selectedContaminants, reportData]);

  useEffect(() => {
    const filteredMapData = [] as any;
    const fieldGroup = 'latlng';
    const sortGroup = 'sortindex';  
    const groupedresults = groupByKey<any, any>(filteredData, i => i[fieldGroup]);
    const chartLabels = uniqueValues(filteredData, fieldGroup)
    for (var i = 0; i < chartLabels.length; i++) {
        const sortedData = [...groupedresults[chartLabels[i]]].sort((x: any, y: any) => x[sortGroup] - y[sortGroup]);
        filteredMapData.push(sortedData[0])
    } 

    const featureCollectionFromReportData = createFeatureCollection([...filteredMapData], catalogsContext.huc12Catalog, huc12InfoCatalogArray, selectedHUC8Value);
/*     setFeatureData(featureCollectionFromReportData);
    if (featureCollectionFromReportData.features.length > 0) {
      if (mapRef && mapRef.current) {
        const mapRef_ = mapRef;
        setTimeout(() => {
          fitBoundsMapData(featureCollectionFromReportData, mapRef_)
        }
          , 400);
      }
    } */
  }, [filteredData]);

  const setChartConfig = (chartAnimation: boolean) => {
    const options = {
      responsive: true,
      maintainAspectRatio: false,
      animation: true,
      scales: {
        y: {
          display: true,
          title: {
            display: true,
            text: 'Measure Value',
            color: 'white'
          },
          ticks: {
            color: 'white',         
          }
        },
        x: {
          display: true,
          title: {
            display: true,
            text: 'PFAS Chemical Name',
            color: 'white'
          },
          ticks: {
            color: 'white',         
          }
        },
      },
      plugins: {
        legend: {
          position: "bottom" as const,
          labels: {
            usePointStyle: true,
          },
          maxHeight: 30,
        } as const,
        title: {
          display: true,
          text: "Result and Detection Limit by PFAS Chemical",
          color: 'white',
          align: 'center',
          padding: 10,
          font: {
            size: 20
          }
        } as const,
        tooltip: {
          padding: 10,
          bodyFont: {
            size: 24
          },
          titleFont: {
            size: 24
          },
          boxPadding: 8,
          usePointStyle: true,
          backgroundColor: '#12234f',
          callbacks: {
            label: function (context: any) {
              const fData = filteredData.filter((o: any) => o["Pfas Chemical Name"].substr(0, 20) === context.label.substr(0, 20));                   
              let label = context.dataset.label || ''; 
              if (label) {
                if(fData.length>0){
                  const thisData = fData[0]; 
                  const thisArray = [];
                  thisArray.push('Result Detection: ' + thisData["Result Detection"])
                  thisArray.push('Result Measure Value: ' + thisData["Result Measure Value"])
                  thisArray.push('Result Unit Of Measure: ' + thisData["Result Unit Of Measure"])

                  thisArray.push('Detection Quantitation Measure Value: ' + thisData["Detection Quantitation  Measure Value"])
                  thisArray.push('Detection Quantitation Unit Of Measure: ' + thisData["Detection Quantitation  Unit Of Measure"])
                  thisArray.push('Count of Result Detection: ' + thisData["Count"])
                  thisArray.push('Year: ' + thisData["Year"])
                  label = thisArray; 
                } else {
                  label = label + ' ' + context.formattedValue;
                } 
              }
              return label;
            }
          }
        } as const,
      } as const,
    } as const;
    setConfig(options);
  }

  const onChartClickHandler = (event: any) => {
    const currentClick = getElementAtEvent(chartRef.current, event)[0];
    if (currentClick) {
      const currentClickMetaData = chartRef.current.getDatasetMeta(currentClick.datasetIndex);
      const currentSite = currentClickMetaData.label;
    }
  }

  const tableColumns = useMemo(
    () => [
      { Header: 'Year', accessor: yearField },
      { Header: 'Location', accessor: locationField },
      { Header: 'Chemical', accessor: chemicalField },
      { Header: 'Maximum Concentration', accessor: 'Maximum Concentration' },
      { Header: 'Workers Potentially Exposed', accessor: 'Number Of Workers Potentially Exposed' },
      { Header: 'Physical Forms', accessor: 'Physical Forms' },
      { Header: 'Imported Lb', accessor: 'Imported Amount  Lb ' },
      { Header: 'Used On Site Lb', accessor: 'Amount Used On Site  Lb ' },
      { Header: 'Exported Lb', accessor: 'Amount Exported  Lb ' },
      { Header: 'Domestic Manufacture Lb ', accessor: 'Domestic Manufacture Amount  Lb ' },
      { Header: 'Production Volume 2010 Lb', accessor: 'Past Production Volume 2010  Lb ' },
      { Header: 'Production Volume 2012 Lb', accessor: 'Past Production Volume 2012  Lb ' },
      { Header: 'Production Volume 2013 Lb', accessor: 'Past Production Volume 2013  Lb ' },
      { Header: 'Production Volume 2014 Lb', accessor: 'Past Production Volume 2014  Lb ' },
      {
        Header: 'EJScreen Report',
        accessor: 'Ejscreen Report',
        Cell: (props: any) => (
          <a
            href={props.value}
            target='_blank'
          >
            EJScreen
          </a>
        ),
      },
      {
        Header: 'Echo Facility Report',
        accessor: 'Echo Facility Report',
        Cell: (props: any) => (
          <a
            href={props.value}
            target='_blank'
          >
            Echo_DFR
          </a>
        ),
      },
      { Header: 'EPA Region', accessor: 'Epa Region' },
      { Header: 'State', accessor: 'State Territory Or Tribe' },
 
      { Header: 'Activity ', accessor: 'Activity' },
      { Header: 'CDR Parent Company', accessor: 'Cdr Parent Company' },

      { Header: 'Chemical Recycled', accessor: 'Chemical Recycled' },
      { Header: 'Identifier', accessor: 'Identifier' },
    ],
    []
  ); 

  const updateLayerStyle = () => {
    const newLayerStyle: LayerProps = {
      id: 'pointlayer',
      type: 'circle' as const,
      paint: {
        'circle-radius': ['get', 'radius'],
        'circle-color': ['match', ['get', 'Result Detection'], 'Below Reporting Limit', '#74add1', 'Not Detected', '#e0f3f8', 'PFAS Detected', '#d73027', 'Present Below Quantification Limit', '#6a3d9a', 'Surface water purchased', '#6a3d9a', '#fee090'],
        'circle-stroke-color': 'white',
        'circle-stroke-width': 1,
        'circle-opacity': 0.8
      }
    };

    setLayerStyle(newLayerStyle);
  }

  const updateHoverLayerStyle = () => {
    const hoverStyle: LayerProps = {
      id: 'hoverlayer',
      type: 'circle' as const,
      paint: {
        'circle-radius': ['get', 'radius'],
        'circle-color': '#000099',
        'circle-stroke-color': 'white',
        'circle-stroke-width': 1,
        'circle-opacity': 1
      }
    };

    setHoverLayerStyle(hoverStyle);
  }



  const onMouseEnter = useCallback((event: any | null) => {
    let isCanceled = false;
    if (event.features && event.features[0] && event.features[0].properties) {
        let newPopup = event.features[0].properties;
        let newLocation = event.features[0].properties[locationField];
        let newHover = event.features[0].properties[locationField];
        const hoverpk = event.features[0].properties.pk;

        let locationHUC = event.features[0].properties.huc8;
        if (locationHUC.length < 8){
            locationHUC = '0' + locationHUC;
        }

        agent.Reports.PFASPr(locationHUC, 0, 100).then((res: any) => {
            if(!isCanceled){
                const resDataArray = [];
                for (var i = 0; i < res.body.length; i++) {
                    for (var j = 0; j < res.body[i].data.length; j++) {
                        resDataArray.push(res.body[i].data[j])
                    }
                } 
                let filterData = [...resDataArray];
                filterData = filterData.filter((o: any) => +o.Pk === +hoverpk);
                if(filterData.length > 0){
                    const newRecord = filterData[0]
                    newRecord.centroid_latitude = newRecord.Latitude; //+++
                    newRecord.centroid_longitude = newRecord.Longitude; //+++ 
                    newRecord.latlng = '' + newRecord.Latitude + newRecord.Longitude; 
                    newRecord.radius = 12;
                    newRecord.name = newRecord[locationField];

                    newPopup = newRecord;
                    newLocation = newRecord[locationField];
                    newHover = newRecord[locationField];

                    setTimeout(() => {
                        setCursor('pointer');
                        setPopupInfo(newPopup);
                        setUserSelectedLocation(newLocation)
                        setHoverLocation([newRecord])
                        setMapHoverFilter(['in', ['get', locationField], newHover]);
                    }
                        , 1);
                }
            } 
        })
    }
 
  }, []);

  const onMouseLeave = useCallback((event: any | null) => {
    setCursor('');
    setTimeout(() => {
      setPopupInfo(null);
      setUserSelectedLocation(null)
      setMapHoverFilter(['in', ['get', locationField], '']);
    }
      , 11);
  }, []);

  useEffect(() => {
    if (usLocations.length > 0) {
      if (userSelectedLocations.indexOf(usLocations[0][locationField]) > -1) {
        setPopupInfo(null);
        setUserSelectedLocations([]);
        setMapHoverFilter(['in', ['get', locationField], '']);
      } else {
        setUserSelectedLocations(usLocations[0][locationField]);
        setPopupInfo(usLocations[0]);
        setHoverLocation([usLocations[0]])
        setTimeout(() => {
          setMapHoverFilter(['in', ['get', locationField], usLocations[0][locationField]]);
        }, 111);
      }
    }
  }, [usLocations]);

  useEffect(() => {
    if (hoverLocation && hoverLocation.length > 0 && clickLocation) {
      /*if (userSelectedLocations.indexOf(clickLocation[0][locationField]) > -1) {
        setUserSelectedLocations([]);
      } else { */
        setUserSelectedLocations(hoverLocation[0]);
        if(clickLocation && clickLocation.length> 0 && clickLocation[0].huc8){
          let huc8 = clickLocation[0].huc8;
          if(huc8.length === 7){
              huc8 = '0' + huc8;
          } 
          selectedHUC8Value = huc8;
          global.setSelectedHUC8(huc8)
        }
      //}
    }
  }, [clickLocation]);

  const onClick = useCallback((event: any | null) => {
    const feature = event.features && event.features[0];
    if (feature) {
      setClickLocation([feature.properties]);
    }
  }, []);

  const onMapLoad = useCallback(() => {
    if (mapRef && mapRef.current) {
      setMapLoaded(true);

      mapRef.current.resize();
    }
  }, []);

  const pointInPolygonUpdate = (pointsSelected: any) => {
        setUserSelectedLocations(pointsSelected);
        setMapHoverFilter(['in', ['get', locationField], ['literal', pointsSelected]]);
  }

  const onDelete = useCallback((e: any | null) => {
    if (mapRef && mapRef.current) {
    setPopupInfo(null);
    setMapHoverFilter(['in', ['get', locationField], '']);
    setUserSelectedLocations([]);
    }
  }, []);

  const renderPopup = () => {
    return (
      <Popup
      
        longitude={Number(popupInfo.centroid_longitude)}
        latitude={Number(popupInfo.centroid_latitude)}
        onClose={() => setPopupInfo(null)}
      >
        <div className="popup-container">
          <div className="popup-content-row">
            <span className="popup-content-label">Location</span>
            <span className="popup-container-location popup-content-value">{popupInfo[locationField]}</span>
          </div>
          <div className="popup-content-row">
            <span className="popup-content-label">Parent Company</span>
            <span className="popup-content-value">{popupInfo["Standardized Parent Company Name"]}</span>
          </div>
          <div className="popup-content-row">
            <span className="popup-content-label">Workers Potentially Exposed</span>
            <span className="popup-content-value">{popupInfo["Number Of Workers Potentially Exposed"]}</span>
          </div>

        </div>
      </Popup>
    )
  }

  const hoverRowHandler = (event: any) => { }

  const clickRowHandler = (event: any) => {
    console.log(mapRef, mapRef.current)   //@ts-ignore
    console.log(userSelectedLocations, userSelectedLocations[locationField],  event[locationField] )
    //@ts-ignore
    if (userSelectedLocations && userSelectedLocations[locationField] === event[locationField] ) { //|| userSelectedLocations.indexOf(event[locationField]) > -1
      setUserSelectedLocations([])
      setPopupInfo(null);
      setMapHoverFilter(['in', ['get', locationField], '']);
    } else {
      setUserSelectedLocations(event)
      setMapHoverFilter(['in', ['get', locationField], event[locationField]])
      setPopupInfo(event);
      if (mapRef.current) {
        if (event && event.centroid_longitude) {
          mapRef.current.flyTo({
            center: [
              parseFloat(event.centroid_longitude),
              parseFloat(event.centroid_latitude),
            ],
          });
        }
      }
    }
  };

  const onHoverOut = useCallback((e: any | null) => {
    setMapHoverFilter(['in', ['get', locationField], '']);
    setPopupInfo(null);
  }, []);

  const onTableClick = useCallback((e: any | null) => {

  }, []);

  const deselectFilters = useCallback((e: any | null) => {
    setPopupInfo(null);
    setMapHoverFilter(['in', ['get', locationField], '']);
    setUserSelectedLocations([]);
  }, []);
  
  return (
    <>
      <FullScreenComp handle={fullscreenhandle} className={'pfas-fullscreen'}>
        <Container fluid className="pfasproduction-container" >
        <div className="pfasproduction"  id='pfasproduction-report'>
          <ReportHeader global={global} data={filteredData} 
            reportID={"pfasproduction-report"} fullScreenClickHandle={fullscreenhandle.enter} />              
            <Row className="container-row-top">
              <Col m={1} className="column-container">
                <div className="map-report-container">
                    <LoadingDataAnimation dataLoading={!isDataReportLoaded} />
                    <Map
                    id="pfasproduction"
                    mapboxAccessToken={settings.maboxKey}
                    mapStyle={global.mapStyle}
                    onLoad={onMapLoad}
                    onClick={(e) => {
                        global.onMapClick(e)
                        onClick(e)
                    }}
                    onMouseEnter={onMouseEnter}
                    onMouseLeave={onMouseLeave}
                    cursor={cursor}
                    preserveDrawingBuffer={true}
                    interactiveLayerIds={['pointlayer']}
                    ref={mapRef as Ref<MapRef>}
                    projection={global.globeView ? 'globe' : 'mercator' as any}
                    >
                    {featureData && (
                        <Source id="circlesource" type="geojson" data={featureData}>
                        <Layer {...layerStyle} />
                        <Layer {...hoverLayerStyle} filter={mapHoverFilter} />
                        </Source>
                    )}

                    <MapAddition global={global} 
                                mapRef={mapRef}
                                onDelete={onDelete}
                                PointInPolygonField={locationField}
                                PointInPolygonUpdate={pointInPolygonUpdate}
                                position={'low'}
                                zipOff={true}
                                MapSliderAdd={true}
                                statusMessage={statusMessage}/>

                    {popupInfo && renderPopup()}

                    <div className='map-legend-container'  style={{display:'none'}} onClick={deselectFilters}>
                          <MapLegend
                          mapLegendData={mapLegendData}
                          title={'Result'}
                          global={global} 
                        />
                    </div>  
       
                    </Map>
                </div>             
              </Col>

            </Row>

            <Row className="container-row-bottom">     
                <div
                    className={isFullScreenActive ? 'row gx-0 table-chart-row table-parent-container expand-container' : 'row gx-0 table-chart-row table-parent-container'}
                    onMouseLeave={onHoverOut}
                    onClick={onTableClick}>
                    <div className="report-options">
                        <Button variant="light" onClick={fullscreenContainerHandler}>
                            <img src={fullscreenIcon} />
                        </Button>
                    </div>
                    <ReportTableExpanded
                        data={filteredData}
                        columns={tableColumns}
                        clickRowHandler={clickRowHandler}
                        clickLoadStop={true}
                    />
                </div>                            
            </Row>

            <Row>
                <ReportFooter />
            </Row>

          </div>
        </Container>
        
      </FullScreenComp>
    </>
  );
}

type PfasProductionModel = {
  lat: number;
  lng: number;
};
